import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AsyncPipe,
  NgComponentOutlet,
  NgTemplateOutlet,
} from '@angular/common';
import { B2bDynamicLoaderPipe } from '@app/b2b-dynamic-lib/pipes/b2b-dynamic-loader-pipe.pipe';
import { B2bMenuCardComponent } from '@app/new-ui-lib/b2b-cards/components/b2b-menu-card/b2b-menu-card.component';
import { IntersectionObserverDirective } from '@app/components/directives/intersection-observer/intersection-observer.directive';
import { ContainerModel, LayoutModel } from '@app/models/server/layout.model';
import { Observable, Subscription } from 'rxjs';
import { UserModel } from '@app/models/server/user.model';
import { PAGE_TYPES } from '@app/constants/app-settings';
import { IntersectionStatus } from '@app/components/directives/intersection-observer/from-intersection-observer';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '@app/store';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { SeoSetupService } from '@b2b/seo-util-lib';
import * as fromUser from '@app/store/init-user';
import { HttpErrorResponse } from '@angular/common/http';
import { B2bShortstayFormComponent } from '@app/new-ui-lib/b2b-search/components/b2b-desktop/b2b-shortstay-form/b2b-shortstay-form.component';
import { B2bSlidersComponent } from '@app/new-ui-lib/b2b-sliders/components/b2b-sliders/b2b-sliders.component';
import { B2bLoginPopOverComponent } from '@app/new-ui-lib/b2b-promotional-popovers/components/b2b-login-pop-over/b2b-login-pop-over.component';

@Component({
  selector: 'lib-desktop-web-home-page',
  templateUrl: './desktop-web-home-page.component.html',
  styleUrls: ['./desktop-web-home-page.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    B2bDynamicLoaderPipe,
    B2bMenuCardComponent,
    IntersectionObserverDirective,
    NgComponentOutlet,
    NgTemplateOutlet,
    B2bShortstayFormComponent,
    B2bSlidersComponent,
    B2bLoginPopOverComponent,
  ],
})
export class DesktopWebHomePageComponent implements OnInit, OnDestroy {
  @Input() layoutData: LayoutModel;

  userInfo$: Observable<UserModel>;

  errorContainers: ContainerModel[] = [];

  pageType: string = PAGE_TYPES.HOME_PAGE;

  // @ViewChild('ionRefresh') ionRefresh: IonRefresher;

  isDesktop: boolean = this.b2bDeviceUtilService?.isDesktop();
  isServer: boolean = this.b2bDeviceUtilService?.isServer();

  visibilityStatus: { [key: number]: IntersectionStatus } = {};

  intersectionStatus = IntersectionStatus;

  initSeoDataSubscription$: Subscription;

  constructor(
    private rootStore: Store<fromRoot.State>,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private seoSetupService: SeoSetupService,
  ) {}

  ngOnInit() {
    if (this.layoutData?.mainContainer?.length > 0) {
      // no need to do anything
    } else {
      this.loadSeoData();
    }
    this.userInfo$ = this.rootStore.pipe(select(fromUser.getUser));
  }

  onVisibilityChanged(index: number, status: IntersectionStatus) {
    this.visibilityStatus[index] = status;
  }

  /*
    trackByIndex(index: number) {
      return index;
    }
  */

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  ionViewDidLeave(): void {
    this.unsubscribe();
  }

  loadSeoData() {
    this.initSeoDataSubscription$ = this.seoSetupService
      .initSeoData()
      .subscribe({
        next: (layoutData: LayoutModel) => {
          this.layoutData = layoutData;
        },
        error: (errorResponse: HttpErrorResponse) => {
          /*LoggerService.error('errorResponse is ', errorResponse);*/
        },
      });
  }

  unsubscribe() {
    if (this.initSeoDataSubscription$) {
      this.initSeoDataSubscription$.unsubscribe();
    }
  }
}
